<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #f0f2f5;
  color: #333;
}

/* 富文本题目展示：化学式小图与文字同行对齐 */
.rich-html img.inline-formula {
  display: inline !important;
  vertical-align: middle;
  max-height: 3.2em;
  width: auto !important;
  height: auto !important;
  margin: 0 2px;
  object-fit: contain;
}

/* 题库列表选项区：化学式图与选项文字等高（v-html 内容需全局样式） */
.q-options .rich-html img,
.q-options .rich-html img.inline-formula,
.q-options .rich-html img.block-diagram {
  display: inline !important;
  vertical-align: middle;
  max-height: 1.55em !important;
  max-width: 100%;
  width: auto !important;
  height: auto !important;
  margin: 0 2px;
  object-fit: contain;
}

.q-options .rich-html p,
.q-options .rich-html p:has(img) {
  display: inline;
  margin: 0;
}

.rich-html img.block-diagram {
  display: block !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 8px auto;
}

.rich-html p {
  display: inline;
  margin: 0;
}

.rich-html p:has(.block-diagram) {
  display: block;
  margin: 0.5em 0;
}

.rich-html sub,
.rich-html sup {
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
  position: relative;
}

.rich-html sub {
  bottom: -0.2em;
}

.rich-html sup {
  top: -0.45em;
}

/* 富文本表格：按内容宽度收缩，不撑满整行 */
.rich-html table.table-fit-content,
.rich-html table.question-table.table-fit-content,
.rich-html table,
.rich-html table.question-table {
  display: inline-table;
  border-collapse: collapse;
  width: auto !important;
  max-width: none;
  margin: 8px 0;
  font-size: 13px;
  table-layout: auto !important;
  vertical-align: top;
  border: 1px solid #333;
}

.rich-html table td,
.rich-html table th {
  border: 1px solid #333;
  padding: 6px 8px;
  text-align: left;
  vertical-align: top;
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
  min-width: 40px;
  max-width: min(100%, 420px);
}

.rich-html table th {
  background: #f0f0f0;
  font-weight: 600;
  text-align: center;
}

.rich-html table p {
  display: block;
  margin: 0;
}

.rich-html table p + p {
  margin-top: 4px;
}

/* 表格内图片必须可见（装置图/实验图），不被行内小图样式压扁或懒加载隐藏 */
.rich-html table img,
.rich-html table img.inline-formula,
.rich-html table img.block-diagram {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  max-width: 100% !important;
  max-height: none !important;
  width: auto !important;
  height: auto !important;
  min-width: 24px;
  min-height: 24px;
  margin: 4px auto;
  object-fit: contain;
}
</style>
